module.exports = "/static/assets/fff00873b289b4bf62356568b8852ff0.gif";